import { render, staticRenderFns } from "./OrderListItem.vue?vue&type=template&id=70c8d047"
import script from "./OrderListItem.vue?vue&type=script&lang=js"
export * from "./OrderListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports